import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import StatusBadgeWithSelector from 'components/StatusBadgeWithSelector/StatusBadgeWithSelector';
import TableRow from 'components/Table/TableRow';
import { EXTEND_DATE_FORMAT } from 'constants/general';
import { VALUE_CHAIN_STATUS } from 'constants/interfaces';
import dayjs from 'dayjs';
import SimpleTableCell from 'pages/UserPages/Launchpad/components/SimpleTableCell/SimpleTableCell';

import type ISimpleValueChainRow from './interfaces/ISimpleValueChainRow';

import styles from './scss/SimpleValueChainRow.module.scss';

// Forked from ValueChainMapTableRow: compact, read-only status, whole row acts as the action.
function SimpleValueChainRow({ valueChainItem, onOpenValueChain }: ISimpleValueChainRow) {
  const { t } = useTranslation();
  const isProcessing = valueChainItem.status === VALUE_CHAIN_STATUS.processing;

  const onHandleOpenVC = () => {
    if (!isProcessing) {
      onOpenValueChain(valueChainItem.id);
    }
  };

  return (
    <TableRow
      className={clsx(styles.row, isProcessing && styles.rowDisabled)}
      onClick={onHandleOpenVC}
    >
      <SimpleTableCell className={styles.nameCell}>
        <p className={styles.clientName}>{valueChainItem.name}</p>
      </SimpleTableCell>
      <SimpleTableCell>
        <p>{dayjs(valueChainItem.updatedAt).format(EXTEND_DATE_FORMAT)}</p>
        <p className={styles.adminName}>
          {t('by')}
          {` ${valueChainItem.updatedBy.firstName} ${valueChainItem.updatedBy.lastName}`}
        </p>
      </SimpleTableCell>
      <SimpleTableCell>
        <StatusBadgeWithSelector
          selectedStatus={valueChainItem.status}
          onStatusChange={() => {}}
          archiveInfo={valueChainItem?.latestArchivation || valueChainItem?.latestStatus}
          isAccessDisabled
        />
      </SimpleTableCell>
    </TableRow>
  );
}

export default SimpleValueChainRow;
